export default {
  products: null,
  productNameToCreate: '',
  productDeletionPending: [],
  productCreationPending: false
}
